
define(['jquery', 'underscore', 'underscore.string'], function($, _, _s) {
  var getSearchString, history, run, searchCallback, searchInputSelector, setSearchString;
  searchInputSelector = null;
  searchCallback = null;
  history = [];
  run = function() {
    var searchKey;
    searchKey = _s.trim(getSearchString());
    if (searchKey === '') {
      $(searchInputSelector).blur();
      return;
    }
    if (_.isFunction(searchCallback)) {
      searchCallback(searchKey);
    }
    return history.push(searchKey);
  };
  getSearchString = function() {
    return $(searchInputSelector).val();
  };
  setSearchString = function(key) {
    return $(searchInputSelector).val(key);
  };
  return {
    init: function(input, callback) {
      searchInputSelector = input;
      if (callback != null) {
        searchCallback = callback;
      }
      return $("form:has(" + searchInputSelector + ")").unbind('submit').submit(function(e) {
        e.preventDefault();
        return run();
      });
    },
    run: run,
    getSearchString: getSearchString,
    setSearchString: setSearchString,
    getHistory: function() {
      return history;
    },
    getPrevSearchString: function() {
      history.pop();
      return history.pop();
    },
    setCallback: function(callback) {
      return searchCallback = callback;
    },
    hide: function() {
      searchInputSelector = null;
      searchCallback = null;
      return history = [];
    }
  };
});
